var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinux(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20.9999C3 20.9999 6 15.5217 6 9.26085C6 7.60037 6.63214 6.0079 7.75732 4.83376C8.88255 3.65962 10.4087 3 12 3C13.5913 3 15.1175 3.65962 16.2427 4.83376C17.3678 6.0079 18 7.60037 18 9.26085C18 15.5217 21 20.9999 21 20.9999M15 13.9565L12 15.89L9 13.9565M8.09999 21C8.49644 20.2872 9.06539 19.6956 9.74984 19.2844C10.4342 18.8731 11.2102 18.6567 12 18.6567C12.7897 18.6567 13.5657 18.8731 14.2501 19.2844C14.9346 19.6956 15.5035 20.2872 15.9 21M9.8133 9.44501C10.2709 9.44501 10.6419 9.65113 10.6419 9.90537C10.6419 10.1596 10.2709 10.3657 9.8133 10.3657C9.35567 10.3657 8.98465 10.1596 8.98465 9.90537C8.98465 9.65113 9.35567 9.44501 9.8133 9.44501ZM14.1407 9.44501C14.5983 9.44501 14.9693 9.65113 14.9693 9.90537C14.9693 10.1596 14.5983 10.3657 14.1407 10.3657C13.683 10.3657 13.312 10.1596 13.312 9.90537C13.312 9.65113 13.683 9.44501 14.1407 9.44501Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.eb51f27075864f5a7e72baca42e80bc0.svg";
export { ForwardRef as ReactComponent };